import { __assign } from "tslib";
import { StoresWidgetID, MINICART_POPUP_URL, PageMap } from '../constants';
import { SiteStore } from './site-store/siteStore';
import { configureWorkerRaven, createControllerRaven, createFakeRaven, withErrorReporting, withViewerScriptErrorReporting, viewerScriptErrorReporter, } from './errorReporter';
import { sentryConfPerController } from './sentryConf';
import { CartActions } from '../cart-actions/cartActions';
import { PubSubManager } from '../pub-sub-manager/pubSubManager';
import { isWorker } from './utils';
function emptyCtrl() {
    return {
        pageReady: function () {
            //
        },
        exports: function () { return ({}); },
    };
}
var defaultOptions = {
    useWorkerRaven: true,
};
function openPopup(config, siteStore) {
    var popupUrl = MINICART_POPUP_URL;
    var cartIconConf = config.filter(function (c) { return c.type === StoresWidgetID.CART_ICON; });
    if (cartIconConf.length && cartIconConf[0].config.externalId) {
        popupUrl += "?externalId=" + cartIconConf[0].config.externalId;
    }
    if (siteStore.experiments.enabled('specs.stores.MobileOpenCartInPopup') && siteStore.isMobile()) {
        popupUrl = popupUrl.replace('cartwidgetPopup', 'cart');
    }
    siteStore.windowApis.openPersistentPopup(
    // tslint:disable-line no-floating-promises
    popupUrl, {
        theme: 'BARE',
        width: '0%',
        height: '100%',
        position: {
            origin: 'FIXED',
            placement: 'TOP_RIGHT',
            x: 0,
            y: 0,
        },
    }, (cartIconConf.length && cartIconConf[0].compId) || config[0].compId);
    siteStore.pubSub.publish('Minicart.isExist', true, true);
}
function getControllerFactory(controllerInstances, controllerFactories, type) {
    var ctrlFactory;
    if (controllerInstances && controllerInstances[type]) {
        var controllerFunction = Object.keys(controllerInstances[type]).filter(function (k) { return k.toLowerCase().indexOf('controller') > -1; })[0];
        ctrlFactory = {
            factory: controllerInstances[type][controllerFunction],
            sentryDSN: sentryConfPerController[type],
        };
    }
    else if (controllerFactories && controllerFactories[type]) {
        ctrlFactory = controllerFactories[type];
    }
    return ctrlFactory;
}
function initController(ctrlFactory, context, props) {
    var ctrl;
    if (ctrlFactory) {
        var reportError_1 = context.createMonitoring(ctrlFactory.sentryDSN);
        var setPropsWithErrorsReporting = function (p) { return props.setProps(withErrorReporting(reportError_1)(p)); };
        ctrl = ctrlFactory.factory({
            config: props.config,
            compId: props.compId,
            context: context,
            setProps: setPropsWithErrorsReporting,
            platformAPIs: props.platformAPIs,
            reportError: reportError_1,
            type: props.type,
            warmupData: props.warmupData,
            wixCodeApi: props.wixCodeApi,
        });
        ctrl = withErrorReporting(reportError_1)(ctrl);
    }
    else {
        ctrl = emptyCtrl();
    }
    return ctrl;
}
export function createViewerScript(controllerFactories, options) {
    if (options === void 0) { options = {}; }
    var context = {};
    options = __assign(__assign({}, defaultOptions), options);
    return withViewerScriptErrorReporting({
        initAppForPage: function (initParams, apis, namespaces, platformServices) {
            var userMonitoringContext = {
                id: initParams.instanceId,
                url: namespaces.location.baseUrl,
                uuid: platformServices.bi.visitorId,
            };
            context.siteStore = new SiteStore(initParams, apis, namespaces, platformServices);
            if (options.useWorkerRaven) {
                configureWorkerRaven(platformServices, userMonitoringContext);
                context.createMonitoring = createControllerRaven(platformServices, userMonitoringContext, context.siteStore);
            }
            else {
                context.createMonitoring = createFakeRaven();
            }
            return context.siteStore
                .loadClientConfig()
                .then(function () {
                if (context.siteStore.experiments &&
                    context.siteStore.experiments.enabled('specs.stores.ExposeCartActionInNamespace')) {
                    var pubSubManager = new PubSubManager(context.siteStore.pubSub);
                    var cartActions_1 = new CartActions(context.siteStore, pubSubManager, 'wixcode', PageMap.CART);
                    namespaces.stores.registerApp({
                        addToCart: function (productId, quantity, opt) { return cartActions_1.addToCart(productId, opt, quantity); },
                    });
                }
            })
                .catch(viewerScriptErrorReporter);
        },
        createControllers: function (controllerConfigs, controllerInstances) {
            var isDesktop = !context.siteStore.isMobile();
            var isViewer = context.siteStore.isSiteMode() || context.siteStore.isPreviewMode();
            var shouldOpenMiniCart = isDesktop && isViewer;
            if (context.siteStore.experiments.enabled('specs.stores.FixMiniCartPreview')) {
                shouldOpenMiniCart = shouldOpenMiniCart && isWorker();
            }
            if (shouldOpenMiniCart) {
                openPopup(controllerConfigs, context.siteStore);
            }
            return controllerConfigs.map(function (props) {
                var ctrlFactory = getControllerFactory(controllerInstances, controllerFactories, props.type);
                var ctrl = initController(ctrlFactory, context, props);
                return Promise.resolve(ctrl);
            });
        },
    });
}
//# sourceMappingURL=createViewerScript.js.map